import { Snackbar } from '#src/atoms/snackbar/Snackbar/index.tsx';
import { Message } from '#src/contexts/snackNotification/SnackMessage/index.tsx';
import type { SnackNotificationOptions } from '#src/contexts/snackNotification/index.ts';
import { Level } from '#src/contexts/snackNotification/index.ts';

type Props = {
  notification: string | null;
  onClose: () => void;
  opts?: SnackNotificationOptions;
};

export const SnackNotification = ({
  onClose,
  notification,
  opts = {},
}: Props) => {
  const { link, autoHideDuration, level = Level.INFO } = opts;
  const defaultAutoHideDuration = link ? null : 5000;

  return (
    <Snackbar
      open={Boolean(notification)}
      autoHideDuration={
        typeof autoHideDuration !== 'undefined'
          ? autoHideDuration
          : defaultAutoHideDuration
      }
      onClose={onClose}
      message={<Message notification={notification} level={level} />}
      action={link}
    />
  );
};
